import React, { useEffect, useState } from 'react';
import Select from 'react-select';

const generateYears = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 25 }, (_, i) => {
    const year = currentYear - i;
    return { value: year, label: year.toString() };
  });
};

const productUsers = [
  {
    label: 'ყველა',
    value: '',
    selected: true,
  },
  {
    label: 'მომხმარებელი',
    value: '1',
  },

  {
    label: 'პროფესიონალი',
    value: '2',
  },
];

export const DangerProductFilter = ({ filtersOptions, filterChanged }) => {
  const handleChange = (prop, name) => {
    filterChanged(prop, name);
  };

  const handleResetFilters = () => {
    window.location.reload();
  };

  return (
    <div className='container mt-4'>
      <div className='card p-4'>
        <div className='row mb-3'>
          <div className='col-md-6'>
            <label className='form-label'>გამომუშავების წელი</label>
            <Select
              placeholder='აირჩიეთ'
              onChange={(val) => {
                handleChange(val, 'search_year');
              }}
              options={generateYears()}
            />
          </div>
          <div className='col-md-6'>
            <label className='form-label'>თავისუფალი ტექსტი</label>
            <input
              onChange={(val) => {
                handleChange(val, 'search_free_text');
              }}
              type='text'
              className='form-control'
            />
          </div>
        </div>

        <div className='row mb-3'>
          <div className='col-md-6'>
            <label className='form-label'>კატეგორია</label>
            <Select
              onChange={(val) => {
                handleChange(val, 'search_category');
              }}
              options={filtersOptions.categories}
            />
          </div>
          <div className='col-md-6'>
            <label className='form-label'>პროდუქტები</label>
            <Select
              options={filtersOptions.product_filters}
              isMulti
              className='basic-multi-select'
              classNamePrefix='select'
              onChange={(val) => {
                handleChange(val, 'search_sub_product');
              }}
            />
          </div>
        </div>

        <div className='row mb-3'>
          <div className='col-md-6'>
            <label className='form-label'>დასახელება</label>
            <input
              onChange={(val) => {
                handleChange(val, 'search_title');
              }}
              type='text'
              className='form-control'
            />
          </div>
          <div className='col-md-6'>
            <label className='form-label'>ბრენდი</label>
            <input
              onChange={(val) => {
                handleChange(val, 'search_brand');
              }}
              type='text'
              className='form-control'
            />
          </div>
        </div>

        <div className='row mb-3'>
          <div className='col-md-6'>
            <label className='form-label'>წარმოშობის ქვეყანა</label>
            <Select
              onChange={(val) => {
                handleChange(val, 'search_manufacture_country');
              }}
              options={filtersOptions.countries}
            />
          </div>
          <div className='col-md-6'>
            <label className='form-label'>რისკის ტიპი</label>
            <Select
              onChange={(val) => {
                handleChange(val, 'search_risk_type');
              }}
              options={filtersOptions.risks}
            />
          </div>
        </div>

        <div className='row mb-3'>
          <div className='col-md-6'>
            <label className='form-label'>საფრთხის დონე</label>
            <Select
              onChange={(val) => {
                handleChange(val, 'search_danger_type');
              }}
              options={filtersOptions.danger_levels}
            />
          </div>
          <div className='col-md-6'>
            <label className='form-label'>პროდუქტის განმარტება:</label>
            <Select
              onChange={(val) => {
                handleChange(val, 'search_usertype');
              }}
              options={productUsers}
            />
          </div>
        </div>

        <div className='d-flex justify-content-start'>
          <button className='btn btn-secondary' onClick={handleResetFilters}>
            გასუფთავება
          </button>
        </div>
      </div>
    </div>
  );
};
